<div class="wrapper">
    @if (splash$ | async; as splash) {
    <div class="splash">
        <app-paragraph class="text-left" [text]="splash.text"></app-paragraph>
        @if (convertedAnswerSetting$ | async; as answerSettings) {
        <app-dynamic-form
            [answers]="answerSettings"
            [questionId]="splash.id"
            [nextButton]="{
                disabled: false,
                type: 'filledPrimary',
                icon_name: 'navigate_next',
                isWhiteIcon: true,
                isOutlined: true,
                isIconAfterLabel: true,
                isIconBeforeLabel: false,
                text: nextQuestionText
            }"
            [backButton]="{
                disabled: !screen.previousScreenId,
                type: 'outlinedPrimary',
                icon_name: 'navigate_before',
                isWhiteIcon: true,
                isOutlined: false,
                isIconBeforeLabel: true,
                text: previousQuestionText
            }"
            (navigateBack)="handleNavigateBack($event)"
            (submitting)="handleSubmit($event)"
        ></app-dynamic-form>
        }
    </div>
    }
</div>
